import { Grid } from "@mui/system";
import { Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import IncomeGapsTable, { INCOME_GAPS_COLUMNS } from "./IncomeGapsTable";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const IncomeGaps = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const incomeGapsMTDData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.incomeGapsMTDData,
  );

  const incomeGapsMTDMetadata = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.incomeGapsMTDMetadata,
  );

  const isFetchedForIncomeData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForIncomeData,
  );

  //-- Extract unique brand names for the search filter (this query uses
  //   brand_display_name, not brand_name).
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (incomeGapsMTDData || []).forEach((r: any) => {
      if (typeof r?.brand_display_name === "string")
        set.add(r.brand_display_name.trim());
    });
    return Array.from(set);
  }, [incomeGapsMTDData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return incomeGapsMTDData;
    return (incomeGapsMTDData || []).filter((row: any) =>
      String(row.brand_display_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [incomeGapsMTDData, choosenBrand]);

  return (
    <>
      <Grid container spacing={2} alignItems="center" px={2} py={1.5}>
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Income Gaps in MTD
          </Typography>
        </Grid>
        <Grid size={4}>
          {/* Common Search bar and download for all tables */}
          <BrandSearchBar
            dataTrackerForSearch="885"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="883"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                INCOME_GAPS_COLUMNS,
                "income-gaps-mtd.csv",
              )
            }
            disabled={
              (incomeGapsMTDData?.length ?? 0) === 0 || !isFetchedForIncomeData
            }
          />
        </Grid>
      </Grid>
      <IncomeGapsTable metadata={incomeGapsMTDMetadata} rows={filteredData} />
    </>
  );
};

export default IncomeGaps;
